/**
 * 商城Vuex-actions
 */
export default {
  // 设置主题颜色
  saveThemeColor(context, themeColor) {
    context.commit('saveThemeColor', themeColor);
  },
  // 保存用户名
  saveToken(context, token) {
    context.commit('saveToken', token);
  },
  // 保存购物车数量
  saveCarCount(context, carCount) {
    context.commit('saveCarCount', carCount);
  },
  // 保存商品信息
  saveGoodsInfo(context, goodsInfo) {
    context.commit('saveGoodsInfo', goodsInfo);
  },
  // 保存购物车信息
  saveCarInfo(context, carInfo) {
    context.commit('saveCarInfo', carInfo);
  },
  // 保存商品类型
  saveModeType(context, modeType) {
    context.commit('saveModeType', modeType);
  },

  // 保存商品类型(品诺下单区分)
  saveGoodsTypeInfo(context, goodsTypeInfo) {
    context.commit('saveGoodsTypeInfo', goodsTypeInfo);
  },
  // 保存商品id
  saveGoodsId(context, goodsId) {
    context.commit('saveGoodsId', goodsId);
  },
  // 保存支付订单信息
  saveOrderInfo(context, orderInfo) {
    context.commit('saveOrderInfo', orderInfo);
  },
  // 保存个人中心type
  savePersonType(context, personType) {
    context.commit('savePersonType', personType);
  },
  // 保存订单类型
  saveOrderType(context, orderType) {
    context.commit('saveOrderType', orderType);
  },
  // 保存订单id
  saveOrderId(context, orderId) {
    context.commit('saveOrderId', orderId);
  },
  // 保存退款商品信息
  saveRefundInfo(context, refundInfo) {
    context.commit('saveRefundInfo', refundInfo);
  },
  // 保存售后订单id
  saveAfterSaleId(context, afterSaleId) {
    context.commit('saveAfterSaleId', afterSaleId);
  },
  // 保存售后订单商品id
  saveAfterSaleGoodsId(context, afterSaleGoodsId) {
    context.commit('saveAfterSaleGoodsId', afterSaleGoodsId);
  },
  // 保存栏目id
  saveColumnId(context, columnId) {
    context.commit('saveColumnId', columnId);
  },
  // 保存栏目分类id
  saveColumnClassId(context, columnClassId) {
    context.commit('saveColumnClassId', columnClassId);
  },
  // 保存栏目title
  saveColumnTitle(context, columnTitle) {
    context.commit('saveColumnTitle', columnTitle);
  },
  // 保存分类id
  saveCategoryId(context, categoryId) {
    context.commit('saveCategoryId', categoryId);
  },
  // 保存分类标题
  saveCategoryTitle(context, categoryTitle) {
    context.commit('saveCategoryTitle', categoryTitle);
  },
  // 保存recommendType
  saveRecommendType(context, recommendType) {
    context.commit('saveRecommendType', recommendType);
  },
  // 保存品牌id
  saveBrandId(context, brandId) {
    context.commit('saveBrandId', brandId);
  },
  // 保存消息type
  saveMessageType(context, messageType) {
    context.commit('saveMessageType', messageType);
  },
  // 保存活动ID
  saveActivityId(context, activityId) {
    context.commit('saveActivityId', activityId);
  },
  // 保存活动分组ID
  saveActivityGroupId(context, activityGroupId) {
    context.commit('saveActivityGroupId', activityGroupId);
  },
  // 保存活动分类标题
  saveActivityTitle(context, activityTitle) {
    context.commit('saveActivityTitle', activityTitle);
  },
  // 保存京东商品类类型
  saveJDGoodsType(context, jdGoodsType) {
    context.commit('saveJDGoodsType', jdGoodsType);
  },
  // 保存充值金额
  saveRechargeMoney(context, rechargeMoney) {
    context.commit('saveRechargeMoney', rechargeMoney);
  },
  // 保存取件地址
  savePickUpAddress(context, pickUpAddress) {
    context.commit('savePickUpAddress', pickUpAddress);
  },
  // 保存收货地址
  saveAddress(context, shippingAddress) {
    context.commit('saveAddress', shippingAddress);
  },
  // 保存京东商品列表信息
  saveJDGoodsInfo(context, jdGoodsInfo) {
    context.commit('saveJDGoodsInfo', jdGoodsInfo);
  },
  // 保存普通商品列表信息
  saveWebGoodsInfo(context, webGoodsInfo) {
    context.commit('saveWebGoodsInfo', webGoodsInfo);
  },
  // 保存蛋糕专区城市ID
  saveCakeCityId(context, cakeCityId) {
    context.commit('saveCakeCityId', cakeCityId);
  },
  // 保存蛋糕专区城市名字
  saveCakeCityName(context, cakeCityName) {
    context.commit('saveCakeCityName', cakeCityName);
  },
  // 保存蛋糕专区经纬度
  saveCakeCityLocation(context, cakeCityLocation) {
    context.commit('saveCakeCityLocation', cakeCityLocation);
  },
  // 保存蛋糕专区商品信息
  saveCakeGoodsInfo(context, cakeGoodsInfo) {
    context.commit('saveCakeGoodsInfo', cakeGoodsInfo);
  },
  // 保存蛋糕专区列表信息
  saveCakeParams(context, cakeParams) {
    context.commit('saveCakeParams', cakeParams);
  },
  // 保存配送规则信息
  saveDeliveryRuleInfo(context, deliveryRuleInfo) {
    context.commit('saveDeliveryRuleInfo', deliveryRuleInfo);
  },
  // 保存品牌信息
  saveCakeBrandInfo(context, cakeBrandInfo) {
    context.commit('saveCakeBrandInfo', cakeBrandInfo);
  },
  // 保存品牌列表信息
  saveCakeBrandGoodsInfo(context, cakeBrandGoodsInfo) {
    context.commit('saveCakeBrandGoodsInfo', cakeBrandGoodsInfo);
  },
  // 保存蛋糕门店信息
  saveCakeShopInfo(context, cakeShopInfo) {
    context.commit('saveCakeShopInfo', cakeShopInfo);
  },
  // 保存蛋糕门店商品信息
  saveCakeShopGoodsInfo(context, cakeShopGoodsInfo) {
    context.commit('saveCakeShopGoodsInfo', cakeShopGoodsInfo);
  },
  // 保存飘窗状态
  saveFloatStatus(context, floatStatus) {
    context.commit('saveFloatStatus', floatStatus);
  },
  // 保存首页分组布局id
  saveLayoutId(context, layoutId) {
    context.commit('saveLayoutId', layoutId);
  },
  // 保存限量特惠搜索信息
  saveSpecialInfo(context, specialInfo) {
    context.commit('saveSpecialInfo', specialInfo);
  },
  // 保存限时秒杀搜索信息
  saveSeckillInfo(context, seckillInfo) {
    context.commit('saveSeckillInfo', seckillInfo);
  },
  // 保存电影城市id
  saveMovieCityId(context, movieCityId) {
    context.commit('saveMovieCityId', movieCityId);
  },
  // 保存电影城市名字
  saveMovieCityName(context, movieCityName) {
    context.commit('saveMovieCityName', movieCityName);
  },
  // 保存电影专区信息
  saveMovieInfo(context, movieInfo) {
    context.commit('saveMovieInfo', movieInfo);
  },
  // 保存卡券专区信息
  saveCouponInfo(context, couponInfo) {
    context.commit('saveCouponInfo', couponInfo);
  },
  // 保存评价商品信息
  saveCommentGoodsInfo(context, commentGoodsInfo) {
    context.commit('saveCommentGoodsInfo', commentGoodsInfo);
  },
  // 保存二三类料专区数据
  saveColumnInfo(context, columnInfo) {
    context.commit('saveColumnInfo', columnInfo);
  },
}